import { render, staticRenderFns } from "./project-summary.vue?vue&type=template&id=6e29b472&scoped=true&"
import script from "./project-summary.vue?vue&type=script&lang=js&"
export * from "./project-summary.vue?vue&type=script&lang=js&"
import style0 from "./project-summary.vue?vue&type=style&index=0&id=6e29b472&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e29b472",
  null
  
)

export default component.exports